document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.querySelector('#age-gate');
    if (!overlay) return;

    const stored = sessionStorage.getItem('age_gate');
    if (stored) {
        try {
            const {ts} = JSON.parse(stored);
            if (Date.now() - ts < 86400000) {
                return; // verified within 24h, leave overlay hidden
            }
        } catch (e) {
            // malformed entry, fall through to show overlay
        }
    }

    // Show overlay
    overlay.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    // Focus trap
    const dayInput = document.querySelector('#ag-day'),
        monthInput = document.querySelector('#ag-month'),
        yearInput = document.querySelector('#ag-year'),
        button = document.querySelector('#ag-check'),
        errorEl = document.querySelector('#ag-error'),
        focusTrap = (e) => {
            if (!overlay.contains(e.target)) {
                dayInput.focus();
            }
        };
    document.addEventListener('focusin', focusTrap);

    dayInput.focus();

    function autoAdvance(input, nextInput, maxLen) {
        input.addEventListener('input', () => {
            if (input.value.length >= maxLen && nextInput) {
                nextInput.focus();
            }
        });
    }

    [dayInput, monthInput, yearInput].forEach(inp => {
        inp.addEventListener('input', (e) => {
            let empty = false;
            [dayInput, monthInput].forEach((el) => {
                if (el.value === '') empty = true
            })
            if(yearInput.value === '' || yearInput.value.length < 4) empty = true

            if(!empty) button.removeAttribute('disabled')
        });
    });

    autoAdvance(dayInput, monthInput, 2);
    autoAdvance(monthInput, yearInput, 2);
    autoAdvance(yearInput, button, 4);

    button.addEventListener('click', trySubmit);

    function showError(msg) {
        errorEl.textContent = msg;
        errorEl.removeAttribute('hidden');
    }

    function clearError() {
        errorEl.textContent = '';
        errorEl.setAttribute('hidden', '');
    }

    function trySubmit() {
        clearError();

        const day = parseInt(dayInput.value, 10);
        const month = parseInt(monthInput.value, 10);
        const year = parseInt(yearInput.value, 10);

        if (!dayInput.value || !monthInput.value || !yearInput.value) {
            showError('Uzupełnij datę urodzenia.');
            return;
        }

        if (isNaN(day) || day < 1 || day > 31) {
            showError('Nieprawidłowy dzień.');
            dayInput.focus();
            return;
        }
        if (isNaN(month) || month < 1 || month > 12) {
            showError('Nieprawidłowy miesiąc.');
            monthInput.focus();
            return;
        }
        if (isNaN(year) || year < 1900 || year > new Date().getFullYear()) {
            showError('Nieprawidłowy rok.');
            yearInput.focus();
            return;
        }

        const today = new Date();
        const birthday = new Date(year, month - 1, day);
        let age = today.getFullYear() - birthday.getFullYear();
        const hadBirthday =
            today.getMonth() > birthday.getMonth() ||
            (today.getMonth() === birthday.getMonth() && today.getDate() >= birthday.getDate());
        if (!hadBirthday) age--;

        if (age >= 18) {
            sessionStorage.setItem('age_gate', JSON.stringify({ts: Date.now()}));
            document.removeEventListener('focusin', focusTrap);
            document.documentElement.style.overflow = '';
            overlay.remove();
        } else {
            const form = document.querySelector('#ag-form'),
                header = document.querySelector('#ag-title');
            form.innerHTML = '<p class="age-gate__deny">Strona jest przeznaczona dla osób powyżej 18 roku życia.</p>';
            header.innerHTML = 'Niestety nie możesz skorzystać z tej strony'
        }
    }
});
